export default "__VITE_ASSET__DRfcsfy6__"